import Team from "../components/Team";
import Testimonials from "../components/Testimonials";
import Values from "../components/Values";
import CTA from "../components/CTA";
import SectionTitle from "../components/common/SectionTitle";
import About from "../components/About";

const AboutPage = () => {
	return (
		<div className="about-page">
			<section className="page-header ">
				<div className="containerr pt-10">
					<h1>About Trivnet Services</h1>
					<p>Your trusted technology partner since 2010</p>
				</div>
			</section>

			<About />

			<Values />
			<Team />
			<Testimonials />
			<CTA />
		</div>
	);
};

export default AboutPage;
